import { get } from 'lodash';
import { routeParse } from 'util/routes';
import { isPluginMode } from 'util/isPluginMode';

export const getAdvancedStep = (path) => {
  let { step } = routeParse(path);
  return step;
};

export const getCurrentPath = (state) => {
  const pathname = get(state, 'routing.locationBeforeTransitions.pathname');
  if(isPluginMode()) {
    return pathname.replace('/variable-rate', '');
  }

  return pathname;
};
export const getRouteFromPath = (path) => path.match(/\/([a-z]+)\//)[1];
export const isAdvancedRoute = (path) => path.startsWith('/advanced');
export const isCreateRoute = (path) => path.startsWith('/create');
export const isEditRoute = (path) => path.startsWith('/edit');
export const isManageRoute = (path) => path.startsWith('/manage');
export const isManualRoute = (path) => path.startsWith('/manual');
